import React from 'react'
import ContactBlock from './ContactBlock'
import HomeIcon from '@material-ui/icons/Home';
import PhoneIcon from '@material-ui/icons/Phone';
import MailOutlineIcon from '@material-ui/icons/MailOutline';

function Contact() {
    return (
        <div className="pt-28 flex flex-col justify-center items-center">
            <div className="text-center">
            <p className="text-2xl sm:text-5xl mb-2" data-aos="fade-down">Contact Me</p>
            <p className="text-sm sm:text-base text-gray-400 w-80" data-aos="fade-up">Want any help? or for any query Feel free to contact me📞 </p>
            </div>
            <div className="flex flex-col sm:flex-row ml-10" data-aos="fade-up">
                <ContactBlock
                Icon={HomeIcon}
                heading="Indra-Colony"
                para="Near bus-stand Talwara, Punjab"
                />
                <ContactBlock
                Icon={PhoneIcon}
                heading=""
                para="+91 623-929-4419"
                />
                <ContactBlock
                Icon={MailOutlineIcon}
                heading=""
                para="ak492016@gmail.com"
                />
            </div>

            <form action="https://formsubmit.co/sawanmehras2@gmail.com" method="POST" className="mt-20" data-aos="fade-up">
                <div className="mb-4 w-full sm:w-[30vw]">
                <input type="text" placeholder="Name" name="name" className="w-full h-12 bg-[#70707034] focus:outline-none pl-5" required/>
                </div>
                <div className="mb-4 w-full sm:w-[30vw]">
                <input type="email" placeholder="Email" name="email" className="w-full h-12 bg-[#70707034] focus:outline-none pl-5" required />
                </div>
                <div className="mb-4 w-full sm:w-[30vw]">
                <input type="text" placeholder="Message" name="message" className="w-full h-12 bg-[#70707034] focus:outline-none pl-5"/>
                </div>
                <input type="hidden" name="_autoresponse" value="Thank You for visiting the sawanmehras.web.app Your response is submitted Successfully and the owner of the site contact you shortly via mail."/>

                {/* <input type="hidden" name="_next" value="https://yourdomain.co/thanks.html"/> */}


                <div className="mb-4 w-full sm:w-[30vw]">
                <button type="Submit" placeholder="Message" className="w-full h-12 bg-[#dbdbdb34] focus:outline-none pl-5 cursor-pointer hover:bg-blue-700">
                    Submit
                </button>
                </div>

            </form>
        </div>
    )
}

export default Contact
